import fetchChatUsers from "../../utils/fetchChatUsers";
import { useEffect, useMemo, useState } from "react";
import AvatarIcon from "../UI/AvatarIcon";
import { useTheme } from "@/utils/theme-context";
import { db } from "@/firebase/firebaseConfig";
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  writeBatch,
} from "firebase/firestore";

const ChatNavigation = ({ onUserSelect, selectedUser }) => {
  const [chatUsers, setChatUsers] = useState([]);
  const adminId = "DyNgoxrjL3RtmQZyeeZ60maTo0F2";
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUsers = useMemo(() => {
    return chatUsers.filter((user) =>
      user.email.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [searchTerm, chatUsers]);

  useEffect(() => {
    setLoading(true);
    const loadChatUsers = async () => {
      const users = await fetchChatUsers();

      setChatUsers(users);
      setLoading(false);
    };

    loadChatUsers();
  }, [setLoading]);

  const { theme } = useTheme();

  const markMessagesAsRead = async (userId) => {
    const q = query(
      collection(db, `chat/${userId}/messages`),
      where("isRead", "==", false),
    );
    const querySnapshot = await getDocs(q);
    const batch = writeBatch(db);

    querySnapshot.forEach((messageDoc) => {
      const messageRef = doc(db, `chat/${userId}/messages`, messageDoc.id);
      batch.update(messageRef, { isRead: true });
    });

    await batch.commit();
  };

  const openChat = async (user) => {
    onUserSelect(user);
    await markMessagesAsRead(user.userId);

    const updatedUsers = await fetchChatUsers();
    setChatUsers(updatedUsers);
  };

  return (
    <div className={`chat-navigation`}>
      <div className="chat-navigation-search">
        <div className="chat-users">
          <input
            type="text"
            placeholder="Поиск по Email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="input input--search"
          />

          {filteredUsers?.map(
            (user) =>
              user.userId !== adminId && (
                <div
                  key={user.userId}
                  className={`chat-users-item chat-users-item--dark  ${
                    selectedUser?.email === user.email
                      ? `chat-users-item--active chat-users-item--active--dark`
                      : ""
                  }   `}
                  onClick={() => openChat(user)}
                >
                  <div className="chat-users-item-name">
                    <AvatarIcon item={user.email} />
                    {user.email}
                  </div>

                  {user.unreadCount > 0 && <div className="unread-badge"></div>}
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatNavigation;
